import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getItem, updateItem } from "../../services/itemService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { getCategories } from "../../services/categoryService";
import Currency from "../common/currency";

class SupplierEditForm extends Form {
  state = {
    data: {
      name: "",
      code: "",
      category_id: "",
      stock: "",
      threshold: "",
    },
    categories: [],
    errors: {},
  };

  schema = {
    name: Joi.string().required().label("Item name"),
    code: Joi.label("Code"),
    category_id: Joi.number().required().label("Category"),
    stock: Joi.number().label("Stock"),
    threshold: Joi.number().label("Threshold"),
  };

  async populateItem() {
    try {
      this.setState({ blocking: true });
      const itemId = this.props.match.params.id;
      const { data: item } = await getItem(itemId);
      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(item) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    const { data: cats } = await getCategories();
    const categories = [{ id: "", name: "All Categories" }, ...cats];

    this.setState({ categories });

    await this.populateItem();
  }

  mapToViewModel(item) {
    return {
      name: item.name,
      code: item.code,
      category_id: item.category.id,
      stock: item.stock,
      threshold: item.threshold,
    };
  }

  doSubmit = async () => {
    try {
      const itemId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(itemId);
      this.setState({ blocking: true });
      await updateItem(data);
      toast.success("Item has been updated successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/items");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update Item</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/items")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update Item</h3>
              <p>Provide the information below to update the item.</p>
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("code", "Code", "text")}
              {this.renderSelect(
                "category_id",
                "Category",
                this.state.categories
              )}

              {this.renderInput("stock", "Stock", "text")}
              {this.renderInput("threshold", "Threshold", "text")}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default SupplierEditForm;
